<mat-toolbar color="primary" class="mat-elevation-z2 top-menu">
  <a routerLink="/" style="color: white; text-decoration: none">Telepost</a>
  <span style="flex: 1 1 auto;"></span>

  <tg-top-nav-user></tg-top-nav-user>
</mat-toolbar>
